import PropTypes from "prop-types";
import get from "lodash.get";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { REQUIRED_MESSAGE } from "../constants/formConstants.js";
import { stringOrNumberPropType } from "../util/propTypeHelper.js";

export default function InputDropDown({
  defaultValue,
  errors = {},
  isControlled = false,
  isDisabled = false,
  isInputNumber = false,
  name,
  options,
  register,
  size = "medium",
  style,
  title,
  validate,
}) {
  return (
    <FormControl
      size={size}
      sx={{ width: "250px", flexWrap: "wrap", ...style }}
    >
      <InputLabel id={`mui-component-select-${name}`}>{title}</InputLabel>
      <Select
        defaultValue={!isControlled ? defaultValue : undefined}
        disabled={isDisabled}
        error={!!get(errors, name)}
        label={title}
        value={isControlled ? defaultValue : undefined}
        {...register(name, {
          required: REQUIRED_MESSAGE,
          valueAsNumber: isInputNumber,
          validate,
        })}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            disabled={option.disabled}
            value={option.value}
          >
            {option.label}
            {!!option.helperText && (
              <Typography variant="caption" sx={{ marginLeft: "5px" }}>
                ({option.helperText})
              </Typography>
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

InputDropDown.propTypes = {
  defaultValue: stringOrNumberPropType.isRequired,
  errors: PropTypes.object,
  isDisabled: PropTypes.bool,
  isControlled: PropTypes.bool,
  isInputNumber: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      helperText: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: stringOrNumberPropType.isRequired,
    })
  ).isRequired,
  register: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
};
